












































































import { Component, Watch, Mixins } from 'vue-property-decorator'
import Axios from 'axios'
import { HistoryViewMixin, LibraryMixin } from '@/mixins'
import { waitForMinimumDelay } from '../../../../helpers/date'
import { spawn, Thread, Worker } from 'threads'
import { timeout } from '../../../../helpers/generic'

enum VIEWS {
  Start = 'start', // Must be start
  Rename = 'rename'
}

@Component({
  components: {
    ProgressLoader: require('@/components/ProgressLoader').default
  }
})
export default class GenreRenamer extends Mixins(HistoryViewMixin, LibraryMixin) {
  loading: boolean = false
  view: VIEWS = VIEWS.Start

  search: string = ''
  genres: string[] = []
  genresFiltered: string[] = []
  selectedGenres: string[] = []
  newGenreName: string | null = null
  customNewGenreName: string | null = null
  debounceTimeout: any = null

  get genresWithoutSelectedGenres(): string[] {
    return this.genres.filter(g => !this.selectedGenres.includes(g))
  }

  get renameDisabled(): boolean {
    return false
    // return !this.newGenreName && !this.customNewGenreName
  }

  async scan() {
    if (this.loading || !this.library) return

    this.loading = true

    const startTime = new Date()

    const worker = await spawn(new Worker('@/helpers/features/genre-renamer'))

    this.genres = await worker.findAllUniqueGenres(this.library.tracks)

    this.updateFilteredGenres()

    await Thread.terminate(worker)

    await waitForMinimumDelay(startTime, 500)

    this.loading = false
  }

  selectAllFiltered() {
    this.selectedGenres = [...new Set(this.selectedGenres.concat(this.genresFiltered))]
  }

  updateFilteredGenres() {
    if (this.search) {
      const s = this.search.toLowerCase().trim()

      this.genresFiltered = this.genres.filter(x => x.toLowerCase().includes(s))
    } else {
      this.genresFiltered = this.genres
    }
  }

  toggleSelected(g: string) {
    const i = this.selectedGenres.findIndex(x => x === g)

    if (i > -1) {
      this.selectedGenres.splice(i, 1)
    } else {
      this.selectedGenres.push(g)
    }
  }

  async renameGenres() {
    if (!this.customNewGenreName && !this.newGenreName) {
      const { result } = await this.$buefy.dialog.confirm({
        type: 'is-warning',
        title: 'Are you sure?',
        message: 'You did not enter a new genre. This will remove the genre from the tracks that have one of the above genres.<br><br>Are you sure you want to do this?'
      })

      if (!result) return
    }

    this.loading = true

    try {
      const {
        data: { tracks, libraryInvalidatedAt }
      } = await Axios.post('/library/rename-genre', {
        sourceGenres: this.selectedGenres,
        targetGenre: this.customNewGenreName
      })

      this.$store.commit('library/replaceTracks', {
        tracks,
        libraryInvalidatedAt
      })

      this.$buefy.notification.open(`Renamed ${this.selectedGenres.length} genre${this.selectedGenres.length === 1 ? '' : 's'}`)
    } catch (error) {
      console.error(error)

      if (this.$store.state.auth.isDemoUser) {
        this.$buefy.notification.open(`Renamed ${this.selectedGenres.length} genre${this.selectedGenres.length === 1 ? '' : 's'}`)
      }
    }

    this.loading = false

    this.goToView(VIEWS.Start)

    this.selectedGenres = []
    this.genres = []
    this.newGenreName = ''
    this.search = ''
  }

  async created() {
    await this.scan()
  }

  @Watch('search')
  watchSearch() {
    clearTimeout(this.debounceTimeout)

    this.debounceTimeout = setTimeout(() => {
      this.updateFilteredGenres()
    }, this.genres.length > 1000 ? 500 : 0)
  }

  @Watch('newGenreName')
  updateCustomGenreName(v: string) {
    this.customNewGenreName = v
  }

  @Watch('$store.state.library.library')
  async watchLibrary() {
    await timeout(10) // Because loading=true during fetchLibrary which invokes this function

    await this.scan()
  }

  @Watch('view')
  watchView() {
    window.scrollTo(0, 0)

    if (this.view === VIEWS.Rename) {
      setTimeout(() => {
        (this.$refs as any).targetGenre.focus()
      }, 50)
    }
  }
}
